@if (!formGroup) {
  <div class="loading">
    <spinner></spinner>
  </div>
}
@if (formGroup) {
  <div>
    <form [formGroup]="formGroup" autocomplete="off">
      <section class="stamdata">
        <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="10px" fxLayoutGap.xs="0">
          <dff-form-control fxFlex [formControl]="formGroup.get('omraadeId')"></dff-form-control>
          <dff-form-control fxFlex [formControl]="formGroup.get('henvendelseTypeId')"></dff-form-control>
        </div>
        <div>
          <dff-form-control [formControl]="formGroup.get('overskrift')"></dff-form-control>
          <mat-form-field>
            <mat-label>Tekst</mat-label>
            <textarea matInput formControlName="tekst" matTextareaAutosize matAutosizeMinRows="2"> </textarea>
          </mat-form-field>
        </div>
      </section>
      <section class="bilag">
        <h2>Bilag</h2>
        <note-bilag-liste [formArray]="formGroup.get('bilag')"></note-bilag-liste>
      </section>
      <section class="opgavestyring">
        <h2>Opgavestyring</h2>
        <note-opgavestyring [formGroup]="formGroup.get('opgavestyring')"></note-opgavestyring>
      </section>
    </form>
  </div>
}
